import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';
import ErrorFallback from './ErrorFallback';

interface ErrorBoundaryProps {
  children: React.ReactNode;
  fallback?: React.ComponentType<{
    error: Error;
    resetErrorBoundary: () => void;
  }>;
}

const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  children,
  fallback = ErrorFallback,
}) => {
  const handleReset = () => {
    // Reload the page to reset the application state
    window.location.reload();
  };

  const handleError = (error: Error, errorInfo: React.ErrorInfo) => {
    // Log error to console for development
    console.error('Error boundary caught an error:', error, errorInfo);

    // Here you could also send the error to your logging service
    // For example: Sentry, LogRocket, etc.
  };

  return (
    <ReactErrorBoundary
      FallbackComponent={fallback}
      onError={handleError}
      onReset={handleReset}
    >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
